// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD6yr8s1uH6-WeL5QhA1I_1KxJBKsh21kI",
  authDomain: "roundprep.firebaseapp.com",
  projectId: "roundprep",
  storageBucket: "roundprep.firebasestorage.app",
  messagingSenderId: "501906744731",
  appId: "1:501906744731:web:9cebf799b00719dca66d3e",
  measurementId: "G-LB1CM5RKP3",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Firebase Analytics requires browser APIs, so skip it during server rendering
// and in unsupported browsers. Importing this module initializes Analytics.
let analytics = null;
const analyticsPromise =
  typeof window === "undefined"
    ? Promise.resolve(null)
    : isSupported()
        .then((supported) => {
          if (!supported) return null;

          analytics = getAnalytics(app);
          return analytics;
        })
        .catch(() => null);

export { app, auth, googleProvider, analytics, analyticsPromise };
